export default __webpack_public_path__ + "static/media/P4.822d39e9.png";